'use strict';

var style = require('./style');

module.exports = style({
  prop: 'letterSpacing',
  key: 'letterSpacings',
  numberToPx: true
});


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/letter-spacing.js
// module id = 4369
// module chunks = 168707334958949